const nMillisecondsInDay = 86400000;

// time different with current time
export const convertAndCalcTimeDiff = (date, time) => {
  const defaultDate = new Date(`${date} ${time} UTC`).toUTCString();

  const utcMilliseconds = new Date(defaultDate).getTime();

  return utcMilliseconds - Date.now();
};

export const checkTimeDifference = (miliseconds) => {
  if (miliseconds <= 0) return true;

  return false;
};

export const preSaleTime = (miliseconds) => {
  if (miliseconds < 0) return "00H : 00M";

  const [hour, minute, second] = new Date(miliseconds)
    .toISOString()
    .slice(11, -5)
    .split(":");

  if (miliseconds > nMillisecondsInDay) {
    const day = Math.floor(miliseconds / nMillisecondsInDay);

    return `${day
      .toString()
      .padStart(2, 0)}D : ${hour}H : ${minute}M :${second}S`;
  }

  return `${hour}H : ${minute}M : ${second}S`;
};
